import React from 'react';

const LunchboxRecords = ({ 
  records, 
  classFilter, 
  typeFilter, 
  onClassFilterChange, 
  onTypeFilterChange, 
  classList 
}) => {
  const lunchboxTypeColors = {
    'A': 'orange',
    'B': 'blue', 
    'C': 'red',
    'D': 'green'
  };

  const lunchboxTypeNames = {
    'A': '家常風味',
    'B': '特式風味',
    'C': '至營推介', 
    'D': '健康素食'
  };

  const lunchboxTypeIcons = {
    'A': '🍳',
    'B': '🍽️',
    'C': '❤️',
    'D': '🌱'
  };

  return (
    <div className="lunchbox-records">
      <div className="records-header">
        <h4>飯盒記錄 ({records.length})</h4>
        
        {/* Filters */}
        <div className="filters">
          <div className="filter-group">
            <label>班級:</label>
            <select 
              value={classFilter} 
              onChange={(e) => onClassFilterChange(e.target.value)}
            >
              <option value="all">全部</option>
              {classList.map(classId => (
                <option key={classId} value={classId}>{classId}</option>
              ))}
            </select>
          </div>
          
          <div className="filter-group">
            <label>飯盒:</label>
            <select 
              value={typeFilter} 
              onChange={(e) => onTypeFilterChange(e.target.value)}
            >
              <option value="all">全部</option>
              <option value="A">A - 家常風味</option>
              <option value="B">B - 特式風味</option>
              <option value="C">C - 至營推介</option>
              <option value="D">D - 健康素食</option>
            </select>
          </div>
        </div>
      </div>

      {records.length === 0 ? (
        <div className="no-records">
          <p>當日暫無飯盒記錄</p>
        </div>
      ) : (
        <div className="records-list">
          {records.map((record) => (
            <div key={record.id} className="record-item">
              <div className="record-info">
                <div className="record-class">{record.class_id}</div>
                <div className="record-student">
                  <span className="student-id">{record.saas_students?.student_id || record.student_id}</span>
                  <span className="student-name">{record.saas_students?.student_name || '學生'}</span>
                </div>
              </div>
              
              <div className={`record-type ${lunchboxTypeColors[record.lunchbox_type]}`}>
                <span className="type-icon">{lunchboxTypeIcons[record.lunchbox_type]}</span>
                <span className="type-label">
                  {record.lunchbox_type} - {lunchboxTypeNames[record.lunchbox_type]}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Statistics */}
      {records.length > 0 && (
        <div className="records-stats">
          <h5>統計</h5>
          <div className="stats-grid">
            {['A', 'B', 'C', 'D'].map(type => {
              const count = records.filter(r => r.lunchbox_type === type).length;
              return (
                <div key={type} className={`stat-item ${lunchboxTypeColors[type]}`}>
                  <span className="stat-icon">{lunchboxTypeIcons[type]}</span>
                  <span className="stat-label">類型 {type}</span>
                  <span className="stat-count">{count}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default LunchboxRecords;
